import { mapGetters, mapActions } from 'vuex';
import state, { initialState } from './state';
import getters, { getterTypes } from './getters';
import actions, { actionTypes } from './actions';
import mutations from './mutations';

export const contactsComputed = mapGetters(Object.keys(getterTypes));
export const contactsMethods = mapActions(Object.keys(actionTypes));

export default {
	state: initialState(),
	getters,
	actions,
	mutations,
};
